module.exports = __webpack_public_path__ + "Montserrat-Regular.9c46095118380d38f12e.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/fonts/montserrat/Montserrat-Regular.ttf
// module id = ../../../../../src/assets/fonts/montserrat/Montserrat-Regular.ttf
// module chunks = styles